import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=8c78b912&scoped=true&"
import script from "./SearchHistory.vue?vue&type=script&lang=ts&"
export * from "./SearchHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=8c78b912&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c78b912",
  null
  
)

export default component.exports